export default {
  PARAMETER: "preview",
  EXPECTED_VALUE: "true"
};
